import {
    Component,
    HostListener,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import { Router } from "@angular/router";
import { MetaService } from "src/app/Services/meta-data.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper/core/";
import { TranslateService } from "@ngx-translate/core";
import { EmbryoService } from "../../../Services/Embryo.service";
import { HomePageService } from "../../../Services/home-page.service";
import Swal from "sweetalert2";

SwiperCore.use([Pagination, Navigation, Autoplay]);

@Component({
    selector: "app-HomeTwo",
    templateUrl: "./HomeTwo.component.html",
    styleUrls: ["./HomeTwo.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class HomeTwoComponent implements OnInit {
    @ViewChild("newSwiper", { static: false }) newSwiper: any;
    @ViewChild("newSwiperLowSlides", { static: false }) newSwiperLowSlides: any;
    multiImages = [];
    smallSwiperConfig: any = {};
    bigSwiperConfig: any = {};
    loading: boolean = false;
    homePageData: any;
    homePageDataAds: any;
    homePageDataCustomAds: any;
    homePageDataSectionsSilders: any[] = [];
    homePageDataAdsShimmer: boolean = true;
    homePageDataCustomAdsShimmer: boolean = true;
    homePageDataSectionsSildersShimmer: boolean = true;
    homePageDataBrands: any;
    bannersCounter: number = 0;
    fakeArray = new Array(6);
    environmentVariables: any;
    categories: any = {
        clothing: [],
        shoes: [],
        accessories: [],
        gadgets: [],
    };
    isDirectionRtl = false;
    direction = "ltr";
    lang: any;
    fullDataSliderProducts: any[] = [];
    homePageDataSectionsSildersFull: any;
    innerWindowWidth: number = 0;
    sliderWidth: number = 0;
    scrollPosition: number = 0;
    brandsList:any=[];
    isSlider: boolean = true;
    currentPageView:any = '';
    currentPageViewUrl='home/sections';

    constructor(
        public embryoService: EmbryoService,
        public translate: TranslateService,
        public homePageService: HomePageService,
        private router: Router,
        private metaService: MetaService,
        private confgServ: StaticPagesService
    ) {
        this.multiImages.length = 6;
        this.getInitilizingData();
        if (
            this.environmentVariables &&
            this.environmentVariables?.PRODUCT_CARD_STYLE != "large"
        ) {
            this.smallSwiperConfig = {
                slidesPerView: 4,
                breakpoints: {
                    1200: {
                        slidesPerView: 4,
                    },
                    900: {
                        slidesPerView: 2.5,
                    },
                    500: {
                        slidesPerView: 2.5,
                    },
                    400: {
                        slidesPerView: this.environmentVariables
                            ?.SHOW_SECTIONS_AS_SLIDER
                            ? 2
                            : 1,
                        spaceBetween: 10,
                    },
                    300: {
                        slidesPerView: 1.5,
                    },
                    100: {
                        slidesPerView: 1,
                    },
                },
                spaceBetween: 10,
                draggable: true,
                navigation: true,
                initialSlide: 0,
                slidesPerGroup: 1,
                centeredSlides: false,
                centeredSlidesBounds: true,
                pagination: false,
                autoplay: {
                    delay: 2500,
                    pauseOnMouseEnter: true,
                },
                loop: true,
                responisve: true,
            };
            this.bigSwiperConfig = {
                slidesPerView: 6,
                draggable: true,
                breakpoints: {
                    1500: {
                        slidesPerView: 6,
                        spaceBetween: 10,
                    },
                    1024: {
                        slidesPerView: 5,
                        spaceBetween: 10,
                    },
                    900: {
                        slidesPerView: 3.5,
                        spaceBetween: 10,
                    },
                    400: {
                        slidesPerView: this.environmentVariables
                            ?.SHOW_SECTIONS_AS_SLIDER
                            ? 2
                            : 1,
                        spaceBetween: 10,
                    },
                    300: {
                        slidesPerView: 1.5,
                    },
                    100: {
                        slidesPerView: 1,
                    },
                },
                spaceBetween: 10,
                navigation: true,
                pagination: false,
                initialSlide: 0,
                slidesPerGroup: 1,
                centeredSlides: false,
                centeredSlidesBounds: true,
                autoplay: {
                    delay: 2500,
                    pauseOnMouseEnter: true,
                },
                loop: true,
                responisve: true,
            };
        } else {
            this.smallSwiperConfig = {
                slidesPerView: 4,
                breakpoints: {
                    1500: {
                        slidesPerView: 3,
                    },
                    1200: {
                        slidesPerView: 2,
                    },
                    900: {
                        slidesPerView: 2,
                    },
                    770: {
                        slidesPerView: 2,
                    },
                    450: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                    },
                    100: {
                        slidesPerView: 1,
                    },
                },
                spaceBetween: 10,
                draggable: true,
                navigation: true,
                initialSlide: 0,
                slidesPerGroup: 1,
                centeredSlides: false,
                centeredSlidesBounds: true,
                pagination: false,
                autoplay: {
                    delay: 2500,
                    pauseOnMouseEnter: true,
                },
                loop: true,
                responisve: true,
            };
            this.bigSwiperConfig = {
                slidesPerView: 4,
                draggable: true,
                breakpoints: {
                    1500: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                    },
                    1280: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                    },
                    1000: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                    },
                    770: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                    450: {
                        slidesPerView: 1.5,
                        spaceBetween: 10,
                    },
                    100: {
                        slidesPerView: 1,
                    },
                },
                spaceBetween: 10,
                navigation: true,
                pagination: false,
                initialSlide: 0,
                slidesPerGroup: 1,
                centeredSlides: false,
                centeredSlidesBounds: true,
                autoplay: {
                    delay: 2500,
                    pauseOnMouseEnter: true,
                },
                loop: true,
                responisve: true,
            };
        }
    }

    getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
        });
    }

    ngOnInit() {
        this.lang = localStorage.getItem("lang");
        if (this.lang == "en") {
            this.metaService.setTitle(
                `${
                    this.environmentVariables?.sloganEn ||
                    this.environmentVariables?.APP_NAME
                }`
            );
               this.metaService.setDescription(
                     `${this.environmentVariables?.metaDescriptionEn ? this.environmentVariables?.metaDescriptionEn   : 
                      `Shop for it at ${this.environmentVariables?.WEBSITE_URL}. Shop Quality with direct Delivery or Pickup. It's now easier than ever to buy  it online from ${this.environmentVariables?.WEBSITE_URL}`}`
                    );
        } else {
            this.metaService.setTitle(
                `${
                    this.environmentVariables?.sloganAr ||
                    this.environmentVariables?.APP_NAME_AR
                }`
            );
                this.metaService.setDescription(
                 `${this.environmentVariables?.metaDescriptionAr ? this.environmentVariables?.   metaDescriptionAr : 
                   `عِدْ إلى متجرنا على الإنترنت${this.environmentVariables?.WEBSITE_URL}.وتسوّق بجودة عالية مع التوصيل المباشر أو الاستلام. أصبح الآن أسهل من أي وقتٍ مضى شراء ما تحتاجه عبر الإنترنت من${this.environmentVariables?.WEBSITE_URL}`
                  }`
               );
        }
        this.bannersCounter = 0;
        this.translate.setDefaultLang(this.lang);
        this.getHomePageData();
        this.innerWindowWidth = window.innerWidth;

        this.embryoService.emitLang.subscribe((lang: string) => {
            if (lang && lang !== this.lang) {
                this.isDirectionRtl = lang === "en";
                this.translate.setDefaultLang(lang);
                this.getHomePageData();
                this.lang = lang;
                if (this.lang == "en") {
                    this.metaService.setTitle(
                        `${
                            this.environmentVariables?.sloganEn ||
                            this.environmentVariables?.APP_NAME
                        } `
                    );
                      this.metaService.setDescription(
                     `${this.environmentVariables?.metaDescriptionEn ? this.environmentVariables?.metaDescriptionEn   : 
                      `Shop for it at ${this.environmentVariables?.WEBSITE_URL}. Shop Quality with direct Delivery or Pickup. It's now easier than ever to buy  it online from ${this.environmentVariables?.WEBSITE_URL}`}`
                    );
                } else {
                    this.metaService.setTitle(
                        `${
                            this.environmentVariables?.sloganAr ||
                            this.environmentVariables?.APP_NAME_AR
                        } `
                    );
                      this.metaService.setDescription(
                 `${this.environmentVariables?.metaDescriptionAr ? this.environmentVariables?.   metaDescriptionAr : 
                    `عِدْ إلى متجرنا على الإنترنت${this.environmentVariables?.WEBSITE_URL}.وتسوّق بجودة عالية مع التوصيل المباشر أو الاستلام. أصبح الآن أسهل من أي وقتٍ مضى شراء ما تحتاجه عبر الإنترنت من${this.environmentVariables?.WEBSITE_URL}`
                  }`
               );
                }
            } else {
                this.direction = "rtl";
            }
        });
       
        this.embryoService.brandsList.subscribe(res=>{
          this.brandsList = res;
        })
    }

    @HostListener("window:resize", ["$event"])
    @HostListener("window:orientationchange", ["$event"])
    getInnerWidth(event: any) {
        this.innerWindowWidth = window.innerWidth;
    }

    getHomePageData() {
        this.scrollPosition = window.pageYOffset;

        window.scroll(0, 0);

        this.loading = true;

        this.homePageService.loadingCategoriesEmit(true);
        this.homePageService.getHomeAdsData().subscribe({
            next: (rep) => {
                this.homePageDataAdsShimmer = false;
                if (rep.code === 200) {
                    this.homePageDataAds = rep.data;
                } else {
                    Swal.fire({
                        html: `<p style='color:white'>${rep.message}</p>`,
                        width: 250,
                        position: "bottom-end",
                        background: "#bd362f",
                        timerProgressBar: true,
                        showConfirmButton: false,
                        timer: 3000,
                        backdrop: false,
                        allowOutsideClick: true,
                    });
                }
            },
        });

        this.homePageService.getHomeCustomAdsData().subscribe({
            next: (rep) => {
                this.homePageDataCustomAds = rep.data;

                if (rep.code === 200) {
                    this.homePageDataCustomAdsShimmer = false;
                    if (
                        this.homePageDataSectionsSilders &&
                        this.homePageDataSectionsSilders.length
                    ) {
                        this.homePageDataSectionsSilders.forEach(
                            (element: any) => {
                                element["banners"] = this.dynamicBanners();
                            }
                        );
                    }
                } else {
                    Swal.fire({
                        html: `<p style='color:white'>${rep.message}</p>`,
                        width: 250,
                        position: "bottom-end",
                        background: "#bd362f",
                        timerProgressBar: true,
                        showConfirmButton: false,
                        timer: 3000,
                        backdrop: false,
                        allowOutsideClick: true,
                    });
                }
            },
        });
    }


    bannerRouting(slide: any) {
        if (slide.type === 0 || slide.type === null) {
            return;
        } else if (slide.type === 1) {
            this.router.navigateByUrl(
                "/" +
                    this.lang +
                    `/products/` +
                    (slide.link
                        ? slide.link
                        : slide.name +
                          "/" +
                          slide.item_id +
                          "?variant=" +
                          slide.item_id)
            );
        } else if ((slide.type > 1 && slide.type <= 6) || slide.type == 9) {
            const queryParams: any = {};
            if (slide.type === 2) {
                queryParams.sub_category_id = slide.item_id;
            }
            if (slide.type === 4) {
                queryParams.brand_id = slide.item_id;
            }
            if (slide.type === 5) {
                queryParams.list_ids = slide.item_id;
            }
            if (slide.type === 6) {
                queryParams.category_id = slide.item_id;
            }
            if (slide.type === 9) {
                queryParams.vendor_ids = slide.item_id;
            }
            this.router.navigate(["/" + this.lang + "/products"], {
                queryParams: queryParams,
            });
        } else {
            if (slide.type === 7 && !slide.extrnal) {
                window.open(slide.link, "_self");
            } else {
                window.open(slide.link, "_blank");
            }
        }
    }

    dynamicBanners() {
        if (this.bannersCounter == 0) {
            this.bannersCounter += 6;
        } else {
            this.bannersCounter += 5;
        }
        return this.homePageDataCustomAds.slice(
            this.bannersCounter,
            this.bannersCounter + 5
        );
    }

    floatingBannerRouting(index: number) {
        const floatingBanner = this.homePageDataCustomAds[index];
        if (floatingBanner.item_data) {
            floatingBanner.nameRouter = encodeURIComponent(
                floatingBanner.item_data.name_en.replace(/\s/g, "-")
            );
        }
        const type = floatingBanner.type;
        if (type === 0) {
            return;
        } else if (type === 1) {
            this.router.navigateByUrl(
                `/${this.lang}/${this.homePageDataCustomAds[index].item_data.slug}`
            );
        }
        else if (type > 1 && type <= 6 || type == 9 ) {
            const queryParams: any = {};
            if (type === 2) {
                queryParams.sub_category_id = floatingBanner.item_id;
            }
            if (type === 4) {
                queryParams.brand_id = floatingBanner.item_id;
            }
            if (type === 5) {
                queryParams.list_ids = floatingBanner.item_id;
            }
            if (type === 6) {
                queryParams.category_id = floatingBanner.item_id;
            }
            if (type === 9) {
                queryParams.vendor_ids = floatingBanner.item_id;
            }
         
            this.router.navigate(["/" + this.lang + "/products"], {
                queryParams: queryParams,
            });
        } else {
            if (type === 7 && floatingBanner.extrnal) {
                window.open(floatingBanner.link, "_self");
            } else {
                window.open(floatingBanner.link, "_blank");
            }
        }
    }

    navigateToLink(item: any) {
        if (item.link_en) {
            window.open(item.link_en, "_self");
        }
    }

    load(list: any): void {
        this.router.navigate(["/" + this.lang + "/products"], {
            queryParams: {
                list_ids: list?.list_id,
                name_en: list?.name_en,
                name_ar: list?.name_ar,
            },
        });
    }
}
